// @ts-nocheck
import * as Types from "../../../../../../../types/types";

import { gql } from "@apollo/client";
export type WebhookDeliveryFieldsFragment = {
  __typename?: "WebhookDelivery";
  id: string;
  eventId: string;
  eventType: string;
  status: string;
  attempts: number;
  nextAttemptAt?: number | null;
  lastAttemptAt?: number | null;
  responseStatus?: number | null;
  responseBodyExcerpt?: string | null;
  errorKind?: string | null;
  errorMessage?: string | null;
  payload: any;
  createdAt: number;
  issue?: {
    __typename?: "Issue";
    id: string;
    description: string;
    checkGroupAndName: string;
    server: {
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
    };
    database?: { __typename?: "Database"; id: string } | null;
  } | null;
};

export type IncidentIoDeliveryFieldsFragment = {
  __typename?: "IncidentIoDelivery";
  id: string;
  deduplicationKey: string;
  eventType: string;
  status: string;
  attempts: number;
  nextAttemptAt?: number | null;
  lastAttemptAt?: number | null;
  responseStatus?: number | null;
  responseBodyExcerpt?: string | null;
  errorKind?: string | null;
  errorMessage?: string | null;
  payload: any;
  createdAt: number;
  issue?: {
    __typename?: "Issue";
    id: string;
    description: string;
    checkGroupAndName: string;
    server: {
      __typename?: "Server";
      id: string;
      humanId: string;
      name: string;
    };
    database?: { __typename?: "Database"; id: string } | null;
  } | null;
};

export const WebhookDeliveryFieldsFragmentDoc = gql`
  fragment WebhookDeliveryFields on WebhookDelivery {
    id
    eventId
    eventType
    status
    attempts
    nextAttemptAt
    lastAttemptAt
    responseStatus
    responseBodyExcerpt
    errorKind
    errorMessage
    payload
    createdAt
    issue {
      id
      description
      checkGroupAndName
      server {
        id
        humanId
        name
      }
      database {
        id
      }
    }
  }
`;
export const IncidentIoDeliveryFieldsFragmentDoc = gql`
  fragment IncidentIoDeliveryFields on IncidentIoDelivery {
    id
    deduplicationKey
    eventType
    status
    attempts
    nextAttemptAt
    lastAttemptAt
    responseStatus
    responseBodyExcerpt
    errorKind
    errorMessage
    payload
    createdAt
    issue {
      id
      description
      checkGroupAndName
      server {
        id
        humanId
        name
      }
      database {
        id
      }
    }
  }
`;
